import { render, staticRenderFns } from "./NotenfehlbuchungSVModal.vue?vue&type=template&id=cf4f3e6e&"
import script from "./NotenfehlbuchungSVModal.vue?vue&type=script&lang=js&"
export * from "./NotenfehlbuchungSVModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports